/* !
 * jQuery reception v1.0.0
 * Copyright 2023, Connecty Inc.
 */
(function ($, FUNCTIONS) {
	const a = 'is-active';
	const v = 'is-visible';
	const l = 'is-loading';
	const PATH = '/store/';
	const TITLE = '取扱店舗 | Maruman マルマン株式会社';

	let keyword = '', prefectures = '';
	if (location.search) {
		const searchArr = FUNCTIONS.getQuery();
		for (let i = 0; i < searchArr.length; i++) {
			if (searchArr[i] === 'p_keyword') {
				keyword = decodeURIComponent(searchArr.p_keyword);
			}
			if (searchArr[i] === 'p_prefectures') {
				prefectures = decodeURIComponent(searchArr.p_prefectures);
			}
		}
	}

	// CSV取得
	const csvToArray = (strData) => {
		const strDelimiter = ',';
		const objPattern = new RegExp(
			(
				'(\\' + strDelimiter + '|\\r?\\n|\\r|^)' +
				'(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|' +
				'([^\"\\' + strDelimiter + '\\r\\n]*))'
			),
			'gi'
		);
		let arrData = [[]];
		let arrMatches = null;
		let strMatchedValue;
		while ((arrMatches = objPattern.exec(strData)) !== null) {
			let strMatchedDelimiter = arrMatches[1];
			if (strMatchedDelimiter.length && (strMatchedDelimiter !== strDelimiter)) {
				arrData.push([]);
			}
			if (arrMatches[2]) {
				strMatchedValue = arrMatches[2].replace(new RegExp('\"\"', 'g'), '\"');
			} else {
				strMatchedValue = arrMatches[3];
			}
			arrData[arrData.length - 1].push(strMatchedValue);
		}

		let items = arrData[0];
		let jsonArr = [];
		for (let i = 1; i < arrData.length; i++) {
			if (arrData[i].length) {
				let a_line = {};
				let csvArrayD = arrData[i];
				for (let j = 0; j < items.length; j++) {
					a_line[items[j]] = csvArrayD[j];
				}
				jsonArr.push(a_line);
			}
		}
		return (jsonArr);
	};

	// 都道府県コード順に並べ替える
	const sortListByDisplay = (_json) => {
		let newArr = [];
		_json.forEach(elem => {
			if(elem.display == 1) {
				newArr.push(elem);
			}
		});
		return newArr;
	};
	// 都道府県コード順に並べ替える
	const sortListByPref = (_json) => {
		const PREFCODES = [
		 '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県',
		 '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県',
		 '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県',
		 '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県',
		 '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県',
		 '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
		];
		let newArr = [];
		PREFCODES.forEach(prefelem => {
			let prefectureArr = [];
			_json.forEach(jsonelm => {
				if (jsonelm.prefecture === prefelem) {
					prefectureArr.push(jsonelm);
				}
			});
			newArr.push(prefectureArr);
		});
		// console.log(newArr,'newArr');
		const sortArr = [];
		newArr.forEach(prefelem => {
			// console.log(prefelem,'prefelem');
			let prefelemsort = _.sortBy(
				prefelem,
				['postcode', 'sortShop', 'sortBranch'],
				['asc', 'asc', 'asc'],
			);
			// console.log(prefelemsort,'prefelemsort');
			sortArr.push(prefelemsort);
		});
		// console.log(sortArr,'sortArr');
		let resultArr = [];
		sortArr.forEach(prefelem => {
			prefelem.forEach(elem => {
				resultArr.push(elem);
			});
		});
		console.log(resultArr,'resultArr');
		return resultArr;
	};

	// 全角 → 半角（英数字）
	const hankaku2Zenkaku = (str) => {
		return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
			return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
		});
	};

	// 半角 → 全角（カタカナ）
	const hankana2Zenkana = (str) => {
		let kanaMap = {
			'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
			'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
			'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
			'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
			'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
			'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
			'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
			'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
			'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
			'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
			'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
			'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
			'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
			'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
			'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
			'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
			'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
			'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
			'｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
		};
	
		let reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
		return str
		.replace(reg, function (match) {
			return kanaMap[match];
		})
		.replace(/ﾞ/g, '゛')
		.replace(/ﾟ/g, '゜');
	};

	let csvData = new XMLHttpRequest();
	csvData.open('get', '/store/store.csv', true);
	csvData.send(null);
	csvData.onload = () => {
		let json = csvToArray(csvData.responseText);
		let displaysortjson = sortListByDisplay(json);
		let prefsortjson = sortListByPref(displaysortjson);
		// console.log(prefsortjson,'prefsortjson');

		Vue.createApp({
			data() {
				return {
					jsonData: prefsortjson,
					keyword: keyword,
					pref: prefectures
				}
			},
			methods: {
				searchKeyword() {
					this.pref = '';
					this.keyword = $('#keyword').val();
					$('.store-prefBtn').removeClass(a);
					$('.store-toggle-btn').removeClass(a);
					$('.store-toggleBlock').stop().slideUp(400);
				},
				searchPref() {
					this.keyword = '';
				},
				setTel(_tel) {
					return `tel:${_tel.replace(/-/g, '')}`;
				},
				setHTML(_content) {
					return _content.replace(/\n/g, '<br>');
				}
			},
			computed: {
				filterItems() {
					let items = this.jsonData;
					let itemsTemp = [];

					if (this.keyword) {
						// キーワード検索
						let __keywordmap1 = hankaku2Zenkaku(this.keyword);
						let __keywordmap2 = hankana2Zenkana(__keywordmap1);
						for (let i = 0; i < items.length; i++) {
							if (items[i].postcode.indexOf(__keywordmap2) !== -1 ||
								items[i].address1.indexOf(__keywordmap2) !== -1 ||
								items[i].address2.indexOf(__keywordmap2) !== -1 ||
								items[i].branch.indexOf(__keywordmap2) !== -1 ||
								items[i].shop.indexOf(__keywordmap2) !== -1) {
								itemsTemp.push(items[i]);
							}
						}
						items = itemsTemp;

					// 都道府県検索
					} else if (this.pref !== '') {
						for (let i = 0; i < items.length; i++) {
							if (items[i].prefecture === this.pref) {
								itemsTemp.push(items[i]);
							}
						}
						items = itemsTemp;
					}

					// 県名見出しを作る
					itemsTemp = [];
					let headPref = '';
					for (let i = 0; i < items.length; i++) {
						if (items[i].prefecture !== headPref) { // 初出の都道府県を見出しにする
							itemsTemp.push({ prefhead: items[i].prefecture });
							headPref = items[i].prefecture;
						}
						itemsTemp.push(items[i]);
					}
					items = itemsTemp;

					// 0件の場合
					if (items.length === 0) {
						items.push({ noItem: true });
					}

					return (items);
				}
			},
			mounted() {
				// 初期県名表示
				let initialPref = this.pref;
				$('.store-prefBtn').each(function(index, element) {
					if($(element).val() == initialPref) {
						$(element).addClass(a);
						$(element).parents('.store-toggle').find('.store-toggle-btn').addClass(a);
						$(element).parents('.store-toggle').find('.store-toggleBlock').stop().slideDown(400);
					}
				});
				// 県名アコーディオン
				$('.store-toggle-btn').on('click', (e) => {
					if(!($(e.currentTarget).hasClass(a))) {
						$('.store-toggle-btn').removeClass(a);
						$('.store-toggleBlock').stop().slideUp(400);
						$(e.currentTarget).addClass(a);
						$(e.currentTarget).next('.store-toggleBlock').stop().slideDown(400);
					} else {
						$('.store-toggle-btn').removeClass(a);
						$('.store-toggleBlock').stop().slideUp(400);
					}
				});
				// 県名選択
				$('.store-prefBtn').on('click', (e) => {
					if(!$(e.currentTarget).hasClass(a)) {
						$('.store-prefBtn').removeClass(a);
						$(e.currentTarget).addClass(a);
						this.pref = $(e.currentTarget).val();
					} else {
						$('.store-prefBtn').removeClass(a);
						this.pref = '';
					}
				});
				this.$nextTick(() => {
					$('.store-loader').removeClass(l);
					setTimeout(() => { $('#vue-app').addClass(v); }, 200);
				});
			},
			updated() {
				$('.store-loader').addClass(l);
				$('#vue-app').removeClass(v);

				if (this.keyword) {
					history.replaceState('', TITLE, PATH + `?p_keyword=${this.keyword}`);
				} else if (this.pref !== '') {
					history.replaceState('', TITLE, PATH + `?p_prefectures=${this.pref}`);
				} else {
					history.replaceState('', TITLE, PATH);
				}

				let scrollPos = $('.store-column-contents').offset().top;
				if ($(window).width() < 1025) {
					scrollPos -= 60;
				} else {
					scrollPos -= 50;
				}
				$('html, body').stop().animate({ scrollTop: scrollPos }, 600, 'easeOutExpo');

				setTimeout(() => {
					$('.store-loader').removeClass(l);
					$('#vue-app').addClass(v);
				}, 100);
			}
		}).mount('#vue-app');

	};

})(window.jQuery, window.FUNCTIONS);
